import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./MobilePreviewSectionItem.css";

interface ItemProps {
    title: string;
    description: string;
    date: string;
    imagePath: string;
    url: string;
    buttonLabel: string;
    buttonEnable: boolean;
    isRedirect: boolean;
}

export default function MobilePreviewSectionItem({ title, description, date, imagePath, url, buttonLabel, buttonEnable, isRedirect }: ItemProps) {
    var divStyle = {
        backgroundImage: 'linear-gradient(to bottom, rgba(31, 30, 28, 0), rgba(31, 30, 28, 0), rgba(31, 30, 28, 0.8)), url(' + imagePath + ')',
        height: "40rem",
        backgroundColor: "beige",
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        borderRadius: "20px",
        margin: "3rem 10% 0 10%"
    }

    let navigate = useNavigate();
    const routeChange = () => {
        let path = url;
        navigate(path);
    }


    if (buttonEnable) {
        if (isRedirect) {
            return (
                <div className="info-section" style={divStyle}>
                    <div className="info-wrapper">
                        <div className="wrapper">
                            <h1>{title}</h1>
                            <h2>{date}</h2>
                            <p>{description}</p>
                            <div>
                                <Button variant="outlined" onClick={routeChange} sx={{
                                    cursor: "none",
                                    color: "#f9f0e8", borderColor: "#f9f0e8", borderWidth: "2px", '&:hover': {
                                        cursor: "none",
                                        backgroundColor: '#f9f0e8',
                                        borderWidth: "2px",
                                        borderColor: "#f9f0e8",
                                        color: "#1f1e1c"
                                    }, fontFamily: "Staatliches", width: "100%", fontSize: "xx-large",
                                }}>{buttonLabel}</Button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="info-section" style={divStyle}>
                    <div className="info-wrapper">
                        <div className="wrapper">
                            <h1>{title}</h1>
                            <h2>{date}</h2>
                            <p>{description}</p>
                            <div>
                                <Button variant="outlined" href={url} target="_blank" sx={{
                                    cursor: "none",
                                    color: "#f9f0e8", borderColor: "#f9f0e8", borderWidth: "2px", '&:hover': {
                                        cursor: "none",
                                        backgroundColor: '#f9f0e8',
                                        borderWidth: "2px",
                                        borderColor: "#f9f0e8",
                                        color: "#1f1e1c"
                                    }, fontFamily: "Staatliches", width: "100%", fontSize: "xx-large",
                                }}>{buttonLabel}</Button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    } else {
        return (
            <div className="info-section" style={divStyle}>
                <div className="info-wrapper">
                    <div className="wrapper">
                        <h1>{title}</h1>
                        <h2>{date}</h2>
                        <p>{description}</p>
                        <Button variant="contained" disableElevation disabled sx={{
                            color: "#f9f0e8", '&:disabled': {
                                color: "#f9f0e850",
                                backgroundColor: "#1f1e1c50"
                            }, fontFamily: "Staatliches", width: "100%", fontSize: "xx-large"
                        }}>{buttonLabel}</Button>
                    </div>
                </div>
            </div>
        );
    }
}